import axios from "../../axios";

const updateFee = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('user/fee/updateFee', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateFee;
